var Presets;
(function (Presets) {
    Presets["TODAY"] = "Hoje";
    Presets["YESTERDAY"] = "Ontem";
    Presets["LAST_7_DAYS"] = "\u00DAltimos 7 dias";
    Presets["LAST_30_DAYS"] = "\u00DAltimos 30 dias";
    Presets["THIS_MONTH"] = "Este m\u00EAs";
    Presets["LAST_MONTH"] = "\u00DAltimo m\u00EAs";
})(Presets || (Presets = {}));
export { Presets };
